import { ChatMessage } from './ChatMessage';

export function ChatTranscript({ isLoading, transcript }) {
  if (isLoading) {
    return <div className="rounded-lg border border-mystic-500 bg-white p-6 text-sm text-body-500">Loading chat…</div>;
  }

  if (transcript.length === 0) {
    return (
      <div className="flex min-h-[320px] items-center justify-center rounded-lg border border-dashed border-mystic-500 bg-white p-6 text-center">
        <div>
          <div className="text-lg font-semibold text-body-500">Start a harness chat</div>
          <div className="mt-2 max-w-md text-sm text-body-300">
            Send a prompt to exercise the configured harness, streaming response, history, and client tools.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4 rounded-lg border border-mystic-500 bg-white p-4">
      {transcript.map((entry) => (
        <ChatMessage key={entry.id} entry={entry} />
      ))}
    </div>
  );
}
